export default __webpack_public_path__ + "static/media/2fa_popup.c1f4e96a.png";